import { CustomAnalyticsQueryVersionSchema } from "@redotech/redo-analytics-custom-analytics/query/custom-analytics-report-query";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const publishCustomReportAst = unaryRpc({
  name: "publishCustomReportAst" as const,
  description:
    "Persist a hand-written custom analytics semantic query AST as a stored report for a team, either creating a new report or replacing the AST on an existing one.",
  mutates: true,
  input: z.object({
    version: CustomAnalyticsQueryVersionSchema,
    ast: z.unknown(),
    teamId: z.string().trim().min(1),
    title: z.string().trim().min(1).max(200),
    requestedQuestion: z.string().trim().min(1).max(2000),
    reportSpec: z.string().trim().max(4000).nullable().default(null),
    explanation: z.string().trim().max(2000).nullable().default(null),
    createdByUserId: z.string().trim().min(1),
    targetReportId: z.string().trim().nullable().default(null),
  }),
  output: z.object({
    reportId: z.string(),
    rowId: z.string(),
    revisionNumber: z.number(),
    created: z.boolean(),
    merchantUrl: z.string(),
    columnCount: z.number(),
  }),
});

export type PublishCustomReportAstInput = z.infer<
  typeof publishCustomReportAst.input
>;
export type PublishCustomReportAstOutput = z.infer<
  typeof publishCustomReportAst.output
>;
